'use client';

import React, { SyntheticEvent, useEffect, useState } from 'react';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';

import IconFlag from '@/components/elements/icon/icon-flag';
import Icon2 from '@/components/elements/icon/icon2';
import { useToggle } from '@/hooks/use-toggle';
import { languageDefaultCode, LanguageItem, languages } from '@/i18n/languages';
import { WithLang } from '@/types/general';
import { localeRegExp, storageKeys } from '@/utils/constants';
import { Cookies } from '@/utils/cookies';

export default function ExpanderLanguage(props: WithLang) {
    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();

    const { toggleValue, handleToggle, setToggleValue } = useToggle(false);
    const [selectedLanguage, setSelectedLanguage] = useState<LanguageItem | undefined>();

    useEffect(() => {
        setSelectedLanguage(
            languages.find((language) => language.code === props.lang) ||
                languages.find((language) => language.code === Cookies.get(storageKeys.prefLanguage)) ||
                languages.find((language) => language.code === languageDefaultCode),
        );
    }, [props.lang]);

    const changeLanguage = (newLanguage: LanguageItem) => {
        Cookies.setLocale(storageKeys.prefLanguage, newLanguage.code);

        if (!pathname.match(localeRegExp.exp)?.[2]) return;
        const newPathname = pathname.replace(localeRegExp.exp, localeRegExp.language(newLanguage.code));
        const queryParams = searchParams ? `?${searchParams}` : ``;
        router.push(newPathname + queryParams);
        router.refresh();
    };

    const handleSelect = (e: SyntheticEvent, option: LanguageItem) => {
        e.stopPropagation();
        changeLanguage(option);
        setToggleValue(false);
    };

    return (
        selectedLanguage && (
            <>
                <button
                    className="md:text-regular flex w-full gap-2 whitespace-nowrap px-4 py-4 text-sm"
                    onClick={handleToggle}
                >
                    <span>{selectedLanguage.title}</span>
                    <Icon2
                        name="phi-caret-down-16"
                        iconClass={`h-5 w-5 transition-transform ${toggleValue ? '-scale-y-100' : ''}`}
                    />
                </button>
                {toggleValue &&
                    languages.map((option) => (
                        <button key={option.code} className="w-full px-4 py-4" onClick={(e) => handleSelect(e, option)}>
                            <IconFlag
                                icon={`lang-${option.code}`}
                                text={option.title}
                                sizeSm={5}
                                sizeMd={5}
                                iconClass="rounded-full"
                            />
                        </button>
                    ))}
            </>
        )
    );
}
